import { useSyncExternalStore } from "react";

const COARSE_POINTER_QUERY = "(pointer: coarse)";

function isTouchLikeDevice(): boolean {
  return (
    window.matchMedia(COARSE_POINTER_QUERY).matches || "ontouchstart" in window
  );
}

function subscribe(onStoreChange: () => void): () => void {
  const mq = window.matchMedia(COARSE_POINTER_QUERY);
  mq.addEventListener("change", onStoreChange);
  return () => mq.removeEventListener("change", onStoreChange);
}

function getSnapshot(): boolean {
  return isTouchLikeDevice();
}

function getServerSnapshot(): boolean {
  return false;
}

/** True on phones/tablets; false on SSR and typical desktop pointers. */
export function useIsTouchLikeDevice(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
